import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { createEventBus, removeEventBus, getDispatchData } from '@appbase/util/eventBus';
import { openPopup } from '@appbase/util/popup-helper'

// componemt
import GnbQuickMenuItem from '@gnb/components/GlobalNavigationBarLeft/GnbQuickMenuItem.vue'

const GNB_QUICKMENU_USERSET = '$gnb/pop/setquickmenu';

@Component({
    components: {
        GnbQuickMenuItem
    }
})
export default class GnbQuickMenu extends Vue {
    @Prop({type:Array}) quickMenuItems!: gnb.QuickMenuItem[]
    @Prop({type:String}) userLang!: string
    iconItems: gnb.QuickMenuItem[] = []
    quickItems: gnb.QuickMenuItem[] = []

    fnGetQuickMenuName(quickMenuItem: gnb.QuickMenuItem){
        let menuName = ''
        if (quickMenuItem){
            menuName = (this.userLang.toLowerCase() == 'ko-kr' ? quickMenuItem.title : quickMenuItem.titleEn).toString()
        }
        return menuName
    }

    fnOpenQuickMenuUserSet(){
        openPopup(
            'gnb',
            '/gnb/setquickmenu',
            { },
            {
              width: 900,
              height: 600,
              isFrame: this.isTeams
            }
        )
    }

    @Watch('quickMenuItems')
    fnMakeQuickMenuItem(){
        this.iconItems = this.quickMenuItems.filter(x => x.linkType === 'I')
        this.quickItems = this.quickMenuItems.filter(x => x.linkType === 'Q')
    }

    fnOnChangeQuickMenuUserSet(){
        let quickMenuItems: number[] = getDispatchData(GNB_QUICKMENU_USERSET);
        let quickMenuIds = ((quickMenuItems && quickMenuItems.length > 0) ? quickMenuItems.join(';') : '');
        this.$emit("onInsertQuickMenuUserSet", quickMenuIds);
    }

    created(){
        this.fnMakeQuickMenuItem()

        createEventBus(window, GNB_QUICKMENU_USERSET, this.fnOnChangeQuickMenuUserSet);
    }

    beforeDestroy(){
        removeEventBus(window, GNB_QUICKMENU_USERSET, this.fnOnChangeQuickMenuUserSet);
    }
}